<template>
  <div class="event-results-panel" data-tour="results">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <h3 class="h5 mb-0">
          <span id="event-index-header" v-html="eventIndexHeader"></span>
          <br>
          <small class="text-muted" id="event-index-subheader">{{ locationDescription }}</small>
        </h3>
      </div>
      <div class="d-flex align-items-center">
        <i v-if="isLoading" class="fa fa-spinner fa-spin mr-2"></i>
        <sort-dropdown
          :options="sortOptions"
          :selected="selectedSort"
          :copy="copy.sort"
          @sort-change="handleSortChange"
        ></sort-dropdown>
      </div>
    </div>

    <event-list
      :events="events"
      :isLoading="isLoading"
      :copy="copy"
    ></event-list>

    <nav class="mt-3" v-if="pagination && pagination.totalPages > 1">
      <hd-pagination
        :value="currentPage"
        :page-count="pagination.totalPages"
        :limit="7"
        align="center"
        @input="handlePaginationClick"
      ></hd-pagination>
    </nav>
  </div>
</template>

<script>
import { HdPagination } from '../../ui';
import EventList from './event_list.vue';
import SortDropdown from './sort_dropdown.vue';

export default {
  props: [
    'events',
    'pagination',
    'locationDescription',
    'eventIndexHeader',
    'isLoading',
    'selectedSort',
    'sortOptions',
    'copy',
    'useMetric'
  ],

  // Declared so the parent's onSortChange/onPageChange stay props rather than
  // falling through to $attrs and being bound on the root div as native
  // listeners for events that never fire.
  emits: ['sort-change', 'page-change'],

  data() {
    return {
      currentPage: this.pagination ? this.pagination.currentPage : 1
    };
  },

  components: {
    EventList,
    SortDropdown,
    HdPagination
  },

  watch: {
    pagination: {
      handler(newVal) {
        if (newVal) {
          this.currentPage = newVal.currentPage;
        }
      },
      deep: true
    }
  },

  methods: {
    handleSortChange(sortValue) {
      this.$emit('sort-change', sortValue);
    },

    handlePaginationClick(pageNum) {
      this.currentPage = pageNum;
      this.$emit('page-change', pageNum);
    }
  }
};
</script>
